import { logDOM } from "@testing-library/react";
import React, { useEffect, useState } from "react";
import { GET_USER_DETAILS_MORE_DETAILS } from "../../../utils/constants";
import { getCommonDataBasedOnId } from "../../store/customer/CustomerSocialAddUpdateFunction";
import { getUserToken } from "../../../utils/utilityFunctions/localServices";
import { getInitials, getPersonInitials } from "../../../utils/utilityFunctions/stringUtility";

const EmailPersonInfo = ({ person }) => {
  const [uuid, setUuid] = useState(person?.uuid || null);
  const [userDetails, setUserDetails] = useState(null);

  //to fetch the data of person associated with the uuid
  const fetchDataCustomerAccess = async (customerId, token) => {
    try {
      if (!customerId) return;

      const url = `${GET_USER_DETAILS_MORE_DETAILS}?uuid=${customerId}`;
      const response = await getCommonDataBasedOnId(url, token);

      if (response?.success) {
        setUserDetails(response?.data);
      }
    } catch (error) {
      console.error("Error fetching customer access data:", error);
    }
  };

  useEffect(() => {
    if (uuid) {
      const token = getUserToken();
      fetchDataCustomerAccess(uuid, token);
    }
  }, [uuid]);

  const safeValue = (val) => (val ? val : "Not Available");

  return (
    <div className="w-80 rounded-2xl border border-gray-200 shadow-md bg-white">
      <div className="p-4 space-y-2 text-sm">
        {userDetails && (
          <>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-blue-100 text-blue-700 font-bold text-lg">
                {getInitials(userDetails.user.name)}
              </div>
              <div>
                <div className="text-base font-semibold text-gray-900">{userDetails.user.name || "Unknown User"}</div>
                <div className="text-xs text-gray-500">{safeValue(userDetails.user.email)}</div>
              </div>
            </div>

            {/* Divider */}
            <hr className="border-gray-200" />

            {/* Details */}
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-500">Department</span>
                <span className="font-medium text-gray-900">{safeValue(userDetails.user.department)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">Designation</span>
                <span className="font-medium text-gray-900">{safeValue(userDetails.user.designation)}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailPersonInfo;
